const config = {
    baseURL: '/api',
};
export default config;